import React, { useState } from 'react';

import FormElem from './components/FormElem';
import Finish from './components/Finish';

import useGravityForm from 'hooks/useGravityForm';

const FormContact = () => {
  const [isFinish, setIsFinish] = useState(false);

  // TODO: создать форму
  const submitGravityForm = useGravityForm(1);

  const handleSubmit = (data) => {
    submitGravityForm(data)
      .then(({ confirmation_message }) => {
        console.info(confirmation_message);
        setIsFinish(true);
      })
      .catch((err) => {
        console.error(err.response);
      });

    // setIsFinish(true);
  };

  return (
    <div>
      {!isFinish ? (
        <>
          <div>
            <p className="cr-lead cr-txt-medium">Write us message</p>
            <p className="cr-lead cr-text-2">
              We are looking forward hearing from you!
            </p>
          </div>

          <FormElem onSubmit={handleSubmit} />
        </>
      ) : (
        <Finish />
      )}
    </div>
  );
};

export default FormContact;
